import axios from '../../axios'

/*
 * 省份数据接口
 */
export const getProvinceCacheList = (data) => {
    return axios({
        url: '/api/base/province_cache_list',
        method: 'get',
        data
    })
}

// 获取省份列表
export const getProvinceList = (data) => {
    return axios({
        url: '/api/base/province',
        method: 'get',
        data
    })
}

// 获取省份列表
export const getAllProvinceList = (data) => {
    return axios({
        url: '/api/base/province/admin/all/list',
        method: 'get',
        data
    })
}

// 新增省份信息
export const saveProvince = (data) => {
    return axios({
        url: '/api/base/province',
        method: 'post',
        data
    })
}

// 编辑省份信息
export const updateProvince = (data) => {
    return axios({
        url: '/api/base/province',
        method: 'post',
        data
    })
}

// 删除省份列表
export const deleteProvince = (data) => {
    return axios({
        url: '/api/base/province',
        method: 'delete',
        data
    })
}

// 省份升级
export const upgradeProvinceData = (data) => {
    return axios({
        url: '/api/base/province/upgrade',
        method: 'post',
        data
    })
}

// 省份升级
export const provinceList = [
    { provinceId: 110000, provinceName: '北京' },
    { provinceId: 120000, provinceName: '天津' },
    { provinceId: 130000, provinceName: '河北' },
    { provinceId: 140000, provinceName: '山西' },
    { provinceId: 150000, provinceName: '内蒙古' },
    { provinceId: 210000, provinceName: '辽宁' },
    { provinceId: 220000, provinceName: '吉林' },
    { provinceId: 230000, provinceName: '黑龙江' },
    { provinceId: 310000, provinceName: '上海' },
    { provinceId: 320000, provinceName: '江苏' },
    { provinceId: 330000, provinceName: '浙江' },
    { provinceId: 340000, provinceName: '安徽' },
    { provinceId: 350000, provinceName: '福建' },
    { provinceId: 360000, provinceName: '江西' },
    { provinceId: 370000, provinceName: '山东' },
    { provinceId: 410000, provinceName: '河南' },
    { provinceId: 420000, provinceName: '湖北' },
    { provinceId: 430000, provinceName: '湖南' },
    { provinceId: 440000, provinceName: '广东' },
    { provinceId: 450000, provinceName: '广西' },
    { provinceId: 460000, provinceName: '海南' },
    { provinceId: 500000, provinceName: '重庆' },
    { provinceId: 510000, provinceName: '四川' },
    { provinceId: 520000, provinceName: '贵州' },
    { provinceId: 530000, provinceName: '云南' },
    { provinceId: 610000, provinceName: '陕西' },
    { provinceId: 620000, provinceName: '甘肃' },
    { provinceId: 650000, provinceName: '新疆' }
]



// WEBPACK FOOTER //
// ./src/http/moudules/base/province.js